module.exports = __webpack_public_path__ + "img/03.7580c463.jpg";